import api from 'api-client'
import moment from 'moment'

const state = {
    guestDetailEvents: [],
    selectedEvent: {},
    eventGuests: [],
    requestedTickets: [],
}

const getters = {
    guestDetailEvents: state => state.guestDetailEvents,
    eventGuests: state => state.eventGuests,
    selectedEvent: state => state.selectedEvent,
    requestedTickets: state => state.requestedTickets
}

const mutations = {
    markBooked(state, params) {
        const request = state.requestedTickets.find(requestedTickets => requestedTickets._id === params.id)
        request.status = 'Booked'
    },
    markOffered(state, params) {
        const request = state.requestedTickets.find(requestedTickets => requestedTickets._id === params.id)
        request.status = 'Offered'
    },
    markRejected(state, params) {
        const request = state.requestedTickets.find(requestedTickets => requestedTickets._id === params.id)
        request.status = 'Rejected'
    },
    guestDetailEvents(state, events) {
        return new Promise(resolve => {
            state.guestDetailEvents = events.map((g) => {
                g.dateTo = moment(g.dateTo).format('DD.MM.YYYY')
                g.dateFrom = moment(g.dateFrom).format('DD.MM.YYYY')
                return g;
            })
            resolve(events)
        })
    },
    eventGuests(state, guests) {
        return new Promise(resolve => {
            state.eventGuests = guests.map((g) => {
                g.day_of_attendance = moment(g.day_of_attendance).format('DD.MM.YYYY')
                return g;
            })
            resolve(guests)
        })
    },
    selectedEvent(state, event) {
        return new Promise(resolve => {
            state.selectedEvent = event
            resolve(event)
        })
    },
    requestedTickets(state, requests) {
        return new Promise(resolve => {
            state.requestedTickets = requests.map((g) => {
                g.date_request = moment(g.date_request).format('DD.MM.YYYY')
                return g;
            })
            resolve(requests)
        })
    }
}

const actions = {
    getGuestDetailsEvents(state, params) {
        return api.getGuestDetailsEvents(params)
            .then((result) => {
                state.commit('guestDetailEvents', result)
            })
    },
    getGuestDetailsEvent(state, params) {
        return api.getGuestDetailsEvent(params)
            .then((result) => {
                state.commit('selectedEvent', result[0])
            })
    },
    getEventGuests(state, params) {
        return api.getEventGuests(params)
            .then((result) => {
                state.commit('eventGuests', result)
            })
    },
    updateDefaultPartnerContact({ dispatch }, params) {
        return api.updateDefaultPartnerContact(params.entity, params.partnerId, params.eventId)
            .then((result) => {
                dispatch('getGuestDetailsEvent', params.internalId)
            })
    },
    getTicketRequests(state, params) {
        return api.getTicketRequests(params)
            .then((result) => {
                state.commit('requestedTickets', result)
            })
    },
    async updateMarkBooked({ commit }, params) {
        await api.updateMarkBooked(params)
        commit('markBooked', params)
        return true
    },
    async updateMarkOffered({ commit }, params) {
        await api.updateMarkOffered(params)
        commit('markOffered', params)
        return true
    },
    async updateMarkRejected({ commit }, params) {
        await api.updateMarkRejected(params)
        commit('markRejected', params)
        return true
    },
    getGuestRegistrations(state, params) {
        return api.getEventGuests(params).then(result => {
            return { data: result.items, totalCount: result.total }
        })
    }
}

export default {
    state, getters, mutations, actions
}
